export default "__VITE_PUBLIC_ASSET__d2ba408f__"